import { gql } from 'graphql-request'

export default gql`
  query {
    applications {
      medicalSchedule {
        specialtiesList {
          specialties {
            code
            type
            description
          }
        }
      }
    }
  }
`
